import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import * as z from "zod";

const processingRunStates = ["waiting", "running", "done", "failed"] as const;
export type ProcessingRunState = (typeof processingRunStates)[number];

/** Where a return's processing run stands, for the progress card the merchant can keep open while moving on. */
export const getReturnProcessingProgress = {
  name: "getReturnProcessingProgress" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({
    state: z.enum(processingRunStates),
    type: z.enum(ReturnTypeEnum),
    orderName: z.string().nullable(),
    returnerName: z.string(),
    failureMessage: z.string().nullable(),
  }),
};
